import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { BaseDataService } from './base.data.service';

@Injectable({ providedIn: 'root' })
export class CapacityMatchingService extends BaseDataService {
  url = '/api/capacityMatching';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  public suppliersCapableOfJob(jobId: number, supplierIds: number[]) {
    const req = `${this.url}/suppliersCapableOfJob`;

    let params = this.constructHttpParams({ jobId: jobId, supplierIds: supplierIds });

    return this.handleRequest(
      this.http.get<any>(req, { params: params }),
      this.handlersFactory.getForReadAll(),
    );
  }

  public getCapacityMatches(ecJobId: number): Promise<any> {
    const req = `${this.url}/getCapacityMatches?ecJobId=${ecJobId}`;
    console.log('ECJobs request: ', req);

    return this.handleRequest(this.http.get<any>(req), this.handlersFactory.getForReadAll());
  }
}
